// src/prompts/templates/validatePropertyImage.ts
var validatePropertyImagePrompt = [
  "You are a property image validator for a professional rental platform.",
  "Analyze the provided image against the following criteria:",
  "",
  "1. **Real photograph**: Is this a genuine photograph? Reject AI-generated images, screenshots, text overlays, memes, collages, and digitally rendered interiors.",
  '2. **Category match**: Does the image match the declared category? The category will be provided in the payload JSON (e.g. "bedroom", "bathroom", "exterior", "kitchen", "living_room").',
  "3. **Inappropriate content**: Does the image contain any NSFW, violent, or otherwise inappropriate content?",
  "4. **Text, ads, and watermarks**: Does the image contain overlaid text, advertisements, agent watermarks, or promotional graphics?",
  "5. **Image quality**: Is the image sharp and well-lit? Reject blurry, dark, or extremely low-resolution images.",
  "6. **People**: The image should NOT contain identifiable people. Empty rooms and spaces are expected.",
  "7. **Aesthetic**: Overall image quality and aesthetic appeal should be high. The image should be visually appealing and suitable for a professional rental platform.",
  "8. **General**: The image should NOT contain any clutter, disorganization, or anything that would detract from the property appeal.",
  "",
  "The declared category will be in the payload JSON.",
  "",
  "Respond with ONLY valid JSON in this exact format:",
  "{",
  '  "is_real_photo": true/false,',
  '  "matches_category": true/false,',
  '  "is_appropriate": true/false,',
  '  "has_text_or_watermarks": true/false,',
  '  "is_quality_acceptable": true/false,',
  '  "has_people": true/false,',
  '  "confidence": 0.0-1.0,',
  '  "flags": ["list of specific issues found, empty array if none"],',
  '  "suggested_category": "if it better matches a different category, else null"',
  "}"
].join("\n");

export {
  validatePropertyImagePrompt
};
